import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import axios from 'utils/axios';
/**
 * Utils import
 */
import { creator, errorMessageGenerator } from 'uwork-app-core';

/**
 * Constants
 */
export const REQUEST = '@app/workers/workersprofile/accountSettings/blocked_companies/get/REQUEST';
export const SUCCESS = '@app/workers/workersprofile/accountSettings/blocked_companies/get/SUCCESS';
export const FAILURE = '@app/workers/workersprofile/accountSettings/blocked_companies/get/FAILURE';
export const CLEAR = '@app/workers/workersprofile/accountSettings/blocked_companies/get/CLEAR';

/**
 * Initial state
 */
const initState = {
    data: [],
    loading: false,
    error: ''
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case REQUEST:
                draft.data = [];
                draft.loading = true;
                draft.error = '';
                break;
            case SUCCESS:
                draft.data = payload;
                draft.loading = false;
                break;
            case FAILURE:
                draft.error = payload;
                draft.loading = false;
                break;
            case CLEAR:
                draft.data = [];
                draft.loading = false;
                draft.error = '';
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Selectors
 */

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR)
};

/**
 * Sagas
 */
export const sagas = {
    *request() {
        try {
            const response = yield axios.get('/companies?no-pagination=true&sort_name=asc');
            yield put(actions.success(response.data.data));
        } catch (e) {
            yield put(actions.failure(errorMessageGenerator(e)));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
